import styled from '@emotion/styled'
import React from 'react'

import FormRow from './FormRow'
import Label from './Label'
import { TickIcon } from 'components/icons'
import { formControlReset } from 'styles/reset'

type Props = JSX.IntrinsicElements['input'] & {
	label: React.ReactNode
}

const CheckboxWrapper = styled.div`
	position: relative;
	display: flex;
`

const StyledTickIcon = styled(TickIcon)`
	position: absolute;
	top: 1px;
	left: 1px;
	pointer-events: none;
	color: ${({ theme }) => theme.colors.light.checkbox.tick};
`

const StyledCheckbox = styled.input`
	${formControlReset};
	margin: 0;
	color: currentColor;
	width: 18px;
	height: 18px;
	border-radius: 5px;
	background-color: ${({ theme }) => theme.colors.light.checkbox.inactive};
	cursor: pointer;

	&:checked {
		background-color: ${({ theme }) => theme.colors.light.checkbox.active};
	}
`

const Checkbox = React.forwardRef<HTMLInputElement, Props>(({ label, ...restProps }, ref) => {
	const id = React.useId()
	return (
		<FormRow>
			<CheckboxWrapper>
				<StyledCheckbox type="checkbox" {...restProps} id={id} ref={ref} />
				{restProps.checked && <StyledTickIcon />}
			</CheckboxWrapper>
			<Label htmlFor={id}>{label}</Label>
		</FormRow>
	)
})

Checkbox.displayName = 'Checkbox'

export default Checkbox
